import React from 'react';
import AccountAvatarTrigger from '../avatars/AccountAvatarTrigger';

const onKeyActivate = (event, action) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  action?.();
};

export default function SidePanelPersonRow({
  person = null,
  onSelect,
  resolveSelectPayload,
  rowClassName = 'side-panel-profile side-panel-profile--clickable',
  avatarClassName = 'side-avatar',
  bodyClassName = 'side-profile-body',
  nameClassName = 'side-name',
  metaClassName = 'side-meta',
  eventLabelClassName = 'side-member-events',
  nickname = '',
  nicknameClassName = 'side-nickname',
  name = '',
  meta = '',
  secondaryMeta = '',
  nameStyle,
  avatarStyle,
  avatarFallback = '',
  avatarImageUrl = '',
  avatarImageAlt = '',
  avatarClickableClassName = '',
  avatarNode = null,
  metaClassNameSecondary = '',
  showMeta = false,
  showBadges = false,
  fallbackName = '名称未設定',
}) {
  const payload =
    typeof resolveSelectPayload === 'function'
      ? resolveSelectPayload(person)
      : person;
  const selectable = payload !== undefined && payload !== null;
  const handleSelect = () => {
    if (!selectable) return;
    onSelect?.(payload);
  };

  const displayName = String(name || person?.name || fallbackName);
  const defaultMeta = [person?.position, person?.department].filter(Boolean).join(' / ');
  const displayMeta = String(meta || defaultMeta || '');
  const displaySecondaryMeta = String(secondaryMeta || '');
  const secondaryMetaClass = String(metaClassNameSecondary || metaClassName || '');
  const hasBadges =
    showBadges &&
    (person?.isConcertmaster ||
      person?.isChief ||
      (Array.isArray(person?.customRoles) && person.customRoles.length > 0));
  const hasSupplementalText =
    Boolean(nickname) ||
    (showMeta && Boolean(displayMeta || displaySecondaryMeta)) ||
    Boolean(person?.eventMembershipLabel) ||
    (showBadges && Boolean(person?.eventPartLabel)) ||
    hasBadges;
  const resolvedBodyClassName = [
    bodyClassName,
    !hasSupplementalText ? 'side-profile-body--single-line' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <li
      className={rowClassName}
      onClick={handleSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => onKeyActivate(event, handleSelect)}
    >
      {avatarNode || (
        <AccountAvatarTrigger
          className={avatarClassName}
          clickableClassName={avatarClickableClassName}
          imageUrl={avatarImageUrl || ''}
          imageAlt={avatarImageAlt || displayName || fallbackName}
          style={avatarStyle}
          fallback={avatarFallback || ''}
          onClick={handleSelect}
          stopPropagation
        />
      )}
      <div className={resolvedBodyClassName}>
        {nickname ? <div className={nicknameClassName}>{nickname}</div> : null}
        {hasBadges ? (
            <div className="side-badges-row">
              {person?.isConcertmaster ? (
                <span className="side-badge side-badge--concertmaster">コンサートマスター</span>
              ) : null}
              {person?.isChief ? <span className="side-badge side-badge--chief">首席</span> : null}
              {Array.isArray(person?.customRoles)
                ? person.customRoles.map((role) => (
                    <span
                      key={`${role?.id || role?.name || 'role'}-side`}
                      className="side-badge side-badge--role"
                    >
                      {role?.name || role?.role_name || '役職'}
                    </span>
                  ))
                : null}
            </div>
          ) : null}
        <div className={nameClassName} style={nameStyle}>{displayName}</div>
        {showMeta && displayMeta ? <div className={metaClassName}>{displayMeta}</div> : null}
        {showMeta && displaySecondaryMeta ? (
          <div className={secondaryMetaClass}>{displaySecondaryMeta}</div>
        ) : null}
        {person?.eventMembershipLabel ? (
          <div className={eventLabelClassName}>{person.eventMembershipLabel}</div>
        ) : null}
        {showBadges && person?.eventPartLabel ? (
          <div className={eventLabelClassName}>{person.eventPartLabel}</div>
        ) : null}
      </div>
    </li>
  );
}
